<template>
    <div id="tempcreate-layer">
        <div class="tempcreate-content auto">
            <!-- <el-tabs type="border-card" v-model="tenantId">
				<el-tab-pane :label="item.spaceName" v-for="item in spaceList" :key="item.tenantId" :name="item.tenantId"></el-tab-pane>
			</el-tabs> -->
            <div class="tempcreate-files">
                <h3 class="tempcreate-title">添加文件和签约方</h3>
                <el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="100px"
                    label-position="left" class="files-Form">
                    <el-form-item prop="taskName" label="主题名称" :rules="[
                        { required: true, message: '请输入主题名称', trigger: 'blur' },
                        { validator: checkContractName, trigger: 'blur' },
                    ]">
                        <el-input maxlength="50" v-model="filesForm.taskName" style="width: 70%"></el-input>
                    </el-form-item>
                    <!-- <el-form-item prop="ctype" label="类型" :rules="[
							{ required: currentSpace.companyId, message: '请选择类型', trigger: 'change' }
						]" v-if="currentSpace.companyId">
						<el-select :disabled="isUser" v-model="filesForm.ctype" clearable placeholder="合同类型" style="width: 220px">
							<el-option v-for="item in contractTypes" :key="item.id" :label="item.name" :value="item.id" />
						</el-select>
					</el-form-item> -->
                    <el-form-item prop="signExpireTime" label="签署截止日" :rules="[
                        { required: true, message: '请选择签署截止日', trigger: 'blur' },
                    ]">
                        <el-date-picker style="width: 220px" placeholder="请选择日期" v-model="filesForm.signExpireTime"
                            type="date" :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-form>

                <!-- <div>
					<label>主题名称</label>

					<el-input v-model="taskName" size="small" style="width: 200px;margin-top: 27px;"></el-input>
				</div>
				<div style="margin-top: 20px">
					<label>签署截止日</label>

					<el-date-picker v-model="signExpireTime" size="small" type="date" placeholder="请选择日期">
					</el-date-picker>
				</div> -->
                <div class="tempcreate-upload">
                    <!-- <ul class="el-upload-list el-upload-list--picture-card" v-if="isEdit">
						<li tabindex="0" class="el-upload-list__item is-success">
							<div data-v-0aca0cd4="">
								<img data-v-0aca0cd4="" :src="defaultPDF" alt="" class="el-upload-list__item-thumbnail">
								<span data-v-0aca0cd4="" class="el-upload-list__item-actions">
									<span data-v-0aca0cd4="" class="el-upload-list__item-preview" @click="handleFilePreview()">
										<i data-v-0aca0cd4="" class="el-icon-zoom-in"></i>
									</span>

									<span v-if="!isUser" data-v-0aca0cd4="" class="el-upload-list__item-delete" @click="handleRemove()">
										<i data-v-0aca0cd4="" class="el-icon-delete"></i>
									</span>
								</span>
							</div>
						</li>
					</ul> -->

                    <!-- <div class="uploaded-list">
						<div class="uploaded-item" v-for="file in signFileInfoArray" :key="file.fileId">
							<img class="file-thumb" :src="defaultPDF" alt="">
							<div class="file-name">{{file.fileName}}</div>
							<span class="file-actions">
								<span class="file-preview">
									<i class="el-icon-zoom-in" @click="handleFilePreview(file.fileImgArray, true)"></i>
								</span>
								<span class="file-delete">
									<i class="el-icon-delete" @click="handleRemove(file)"></i>
								</span>
							</span>

						</div>
					</div> -->

                    <el-upload ref="upload" accept=".pdf" :action="templateUploadUrl" list-type="picture-card"
                        :on-change="handleUploaded" :on-success="handleFileSuccess" :on-progress="handleUploading"
                        :on-error="handleFileError" :before-upload="handleTemplateBeforeUpload">
                        <i slot="default" class="el-icon-plus"></i>
                        <div class="upload-tip">上传合同</div>
                        <div slot="file" slot-scope="{ file }" v-loading="file.status == 'uploading'"
                            element-loading-text="文件上传中……">
                            <img class="el-upload-list__item-thumbnail" :src="defaultPDF" alt="" />
                            <div class="file-name">{{ file.name }}</div>
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handleFilePreview(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>

                                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                    <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
                        <img v-for="(img, index) in pngList" :key="index" width="100%" :src="img" alt="" />
                    </el-dialog>
                </div>
                <!-- <p class="upload-tip2" v-if="!isUser">仅支持Word文档模板，文档大小 < 20M</p>
						<div class="upload-progress clearfix" v-show="percentage>0 && percentage< 100">
							<div class="progress-box">
								<el-progress :percentage="percentage"></el-progress>
							</div>
						</div>
						<div class="files-form-box">
							<el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="100px" class="files-Form">
								<el-form-item prop="cname" :label="isUser?'合同名称':'模板名称'" :rules="[
                { required: true, message: '请输入模板名称', trigger: 'blur' },
                { validator: checkContractName, trigger: 'blur' }
              ]">
									<el-input maxlength="50" v-model="filesForm.cname"></el-input>
								</el-form-item>
								<el-form-item prop="ctype" label="类型" :rules="[
                { required: currentSpace.companyId, message: '请选择类型', trigger: 'change' }
              ]" v-if="currentSpace.companyId">
									<el-select :disabled="isUser" v-model="filesForm.ctype" clearable placeholder="合同类型" style="width: 220px">
										<el-option v-for="item in contractTypes" :key="item.id" :label="item.name" :value="item.id" />
									</el-select>
								</el-form-item>
								<el-form-item v-if="isUser" prop="cdate" label="签署截止日" :rules="[
                { required: isUser, message: '请选择签署截止日', trigger: 'blur' }
              ]">
									<el-date-picker style="width: 220px;" v-model="filesForm.cdate" type="date" :picker-options="pickerOptions" value-format="yyyy-MM-dd hh:mm:ss">
									</el-date-picker>
								</el-form-item>
							</el-form>
						</div> -->
            </div>
        </div>

        <div class="tempcreate-users-box auto">
            <div class="add-user-btns" v-if="!isUser">
                <el-button @click="addSignatory('company')" type="primary" plain><i
                        class="el-icon-plus el-icon--right"></i> 添加企业
                </el-button>
                <el-button @click="addSignatory('person')" type="primary" plain><i
                        class="el-icon-plus el-icon--right"></i> 添加个人
                </el-button>
                <!-- <el-button :disabled="isBatch === 1 || isBatch === 0" @click="batchHandle(1)" class="add-btn">批量导入企业<i class="el-icon-plus el-icon--right"></i></el-button>
				<el-button :disabled="isBatch === 1 || isBatch === 0" @click="batchHandle(0)" class="add-btn">批量导入个人<i class="el-icon-plus el-icon--right"></i></el-button> -->
            </div>
            <div class="add-user-btns clearfix" v-else>
                <el-button style="float: left" icon="el-icon-plus" @click="downloadTemplateHandle()" class="add-btn">
                    下载模板</el-button>
                <div style="float: left; height: 36px; overflow: hidden">
                    <el-upload class="upload-demo" ref="tempupload" :file-list="tempList"
                        :on-success="uploadTemplateSuccess" :action="templateUrl">
                        <el-button size="medium" type="primary">上传模板</el-button>
                    </el-upload>
                </div>
            </div>

            <div class="signatory-list">
                <el-card class="signatory-item" v-for="sign in signatoryList" :key="sign.signSequence" shadow="hover">
                    <h3 class="signatory-item-title">
                        签约方-{{ sign.signSubject == "person" ? "个人" : "企业" }}
                    </h3>
                    <div class="signatory-body" v-if="sign.signSubject == 'person'">
                        <span style="width: 10px; color: #f56c6c; margin-right: 4px">*</span>
                        <div class="sub-title">个人信息</div>
                        <div class="signatory-form clearfix">
                            <div class="signatory-form-item">
                                <div class="signatory-form-item-inp">
                                    <!-- <img class="mail-icon" @click="showContactHandle(sign)" src="@/assets/images/sign/mail-icon.png" alt=""> -->
                                    <el-input maxlength="14" placeholder="手机号" v-model="sign.personAddress"
                                        @blur="handleGetSignerInfo(sign, 'person')">
                                    </el-input>
                                    <!-- <div class="tip" v-show="sign.tip">{{sign.tip}}</div> -->
                                </div>
                            </div>
                            <div class="signatory-form-item">
                                <div class="signatory-form-item-inp">
                                    <el-input maxlength="30" placeholder="姓名" v-model="sign.personName"
                                        @blur="handleGetSignerInfo(sign, 'person')" />
                                </div>
                            </div>

                            <!-- <div class="signatory-form-item" v-if="sign.signingBody == 1">
								<div class="signatory-form-item-title">经办人账号</div>
								<div class="signatory-form-item-inp">
									<el-input disabled maxlength="14" v-model="sign.agentAccount" />
								</div>
							</div>
							<div class="signatory-form-item" v-if="sign.signingBody == 1">
								<div class="signatory-form-item-title">经办人姓名</div>
								<div class="signatory-form-item-inp">
									<el-input disabled maxlength="30" v-model="sign.agentName" />
								</div>
							</div> -->
                        </div>

                        <!-- <div class="auth-tag" v-if="sign.tip">
              <span>{{ sign.tip }}</span>
            </div> -->

                        <div class="auth-tag" v-if="sign.tip && sign.tip == '已实名'">
                            <span>{{ sign.tip }}</span>
                        </div>
                        <div class="auth-tag icon-question" v-if="sign.tip && sign.tip == '未实名'">
                            <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                                <div>
                                    <div>添加未认证个人或企业步骤：</div>
                                    <div>
                                        1.
                                        请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                                    </div>
                                    <div>2. 注册成功后完成个人或企业实名认证；</div>
                                    <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                                </div>
                                <div slot="reference" class="auth-tip">
                                    <div class="auth-tip-text">{{ sign.tip }}</div>
                                    <i class="el-icon-question"></i>
                                </div>
                            </el-popover>
                        </div>
                    </div>
                    <div v-else>
                        <div class="signatory-body">
                            <span style="width: 10px; color: #f56c6c; margin-right: 4px">*</span>
                            <div class="sub-title">企业名称</div>
                            <el-input maxlength="14" v-model="sign.companyName" style="width: 500px; margin-right: 34px"
                                @blur="handleGetSignerInfo(sign, 'company')">
                            </el-input>
                            <!-- <div class="auth-tag" v-if="sign.tipCompany">
                <span>{{ sign.tipCompany }}</span>
              </div> -->
                            <div class="auth-tag" v-if="sign.tipCompany && sign.tipCompany == '已实名'">
                                <span>{{ sign.tipCompany }}</span>
                            </div>
                            <div class="auth-tag icon-question" v-if="sign.tipCompany && sign.tipCompany == '未实名'">
                                <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                                    <div>
                                        <div>添加未认证个人或企业步骤：</div>
                                        <div>
                                            1.
                                            请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                                        </div>
                                        <div>2. 注册成功后完成个人或企业实名认证；</div>
                                        <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                                    </div>
                                    <div slot="reference" class="auth-tip">
                                        <div class="auth-tip-text">{{ sign.tipCompany }}</div>
                                        <i class="el-icon-question"></i>
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                        <!-- <div class="signatory-body">
                            <span style="width: 10px; color: #f56c6c; margin-right: 4px">&nbsp;</span>
                            <div class="sub-title">经办人</div>
                            <div class="signatory-form clearfix">
                                <div class="signatory-form-item">
                                    <div class="signatory-form-item-inp">
                                        <el-input maxlength="14" placeholder="手机号" v-model="sign.companyAgentAddress"
                                            @blur="handleGetSignerInfo(sign, 'agent')" />
                                    </div>
                                </div>
                                <div class="signatory-form-item">
                                    <div class="signatory-form-item-inp">
                                        <el-input maxlength="30" placeholder="姓名" v-model="sign.companyAgentName"
                                            @blur="handleGetSignerInfo(sign, 'agent')" />
                                    </div>
                                </div>
                            </div>

                            <div class="auth-tag" v-if="sign.tip && sign.tip == '已实名'">
                                <span>{{ sign.tip }}</span>
                            </div>
                            <div class="auth-tag icon-question" v-if="sign.tip && sign.tip == '未实名'">
                                <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                                    <div>
                                        <div>添加未认证个人或企业步骤：</div>
                                        <div>
                                            1.
                                            请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                                        </div>
                                        <div>2. 注册成功后完成个人或企业实名认证；</div>
                                        <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                                    </div>
                                    <div slot="reference" class="auth-tip">
                                        <div class="auth-tip-text">{{ sign.tip }}</div>
                                        <i class="el-icon-question"></i>
                                    </div>
                                </el-popover>
                            </div>
                        </div> -->
                    </div>

                    <!-- <img
            v-if="!isUser"
            src="@/assets/images/sign/delete.png"
            @click="deleteSignatory(sign.signSequence)"
            class="signatory-delete"
            alt=""
          /> -->
                    <el-button class="signatory-delete" icon="el-icon-delete" circle v-if="!isUser"
                        @click="deleteSignatory(sign.signSequence)"></el-button>
                    <!-- <i class="el-icon-delete signatory-delete" v-if="!isUser" @click="deleteSignatory(sign.signSequence)"></i> -->
                </el-card>

                <el-card class="signatory-batch signatory-item" v-show="isBatch === 1 || isBatch === 0">
                    <h3 class="signatory-item-title">
                        签约方-{{ isBatch == 0 ? "个人" : "企业" }}
                    </h3>
                    <div class="signatory-batch-content">
                        <div>
                            <span class="circle">1</span>
                            <span>下载<el-button type="text">《批量导入企业模板》</el-button></span>
                        </div>
                        <div>
                            <span class="circle">2</span>
                            <span>点此处上传<el-upload class="upload-btn"
                                    action="https://jsonplaceholder.typicode.com/posts/">
                                    <el-button size="small" type="primary">上 传</el-button>
                                </el-upload></span>
                        </div>
                        <div>
                            <span class="circle">3</span>
                            <span>检查核对签约方信息</span>
                        </div>
                        <!-- <div class="signatory-batch-text">
							上传批量{{isBatch === 0 ? '个人' : '企业'}}签约方
						</div> -->
                    </div>
                    <!-- <img v-if="!isUser" @click="deleteBatchSignatory" src="@/assets/images/sign/delete.png" class="signatory-delete" alt=""> -->
                </el-card>

                <el-card class="signatory-batch-success" :class="{ h180: isBatchOk }" v-show="isBatchOk" shadow="hover">
                    <h3 class="signatory-item-title">
                        签约方-批量{{ batchType === 0 ? "个人" : "企业" }}
                    </h3>
                    <div class="signatory-batch-content2">
                        <div class="signatory-batch-text">
                            {{ batchMsg }}
                        </div>
                        <div class="signatory-batch-text">
                            <div style="float: left">
                                <a href="javascript:;" @click="showBatchSignatory" class="show-signatory">点此查看</a>
                                <span>签约方信息</span>
                            </div>
                        </div>
                    </div>
                    <img v-if="!isUser" @click="deleteBatchSignatory" src="@/assets/images/sign/delete.png"
                        class="signatory-delete" alt="" />
                </el-card>
            </div>

            <div class="sign-btns" v-if="!isUser">
                <!-- <el-button type="primary" @click="templateHandle('toSign')">指定签署位置</el-button> -->
                <el-button type="primary" @click="templateHandle('launch')" :disabled="taskStatus != 'draft'">发起签署
                </el-button>
                <el-button plain @click="templateHandle('save')" :disabled="taskStatus != 'draft'">保存草稿</el-button>
            </div>
            <div class="sign-btns" v-else>
                <el-button type="primary" :disabled="clickSubmit" @click="templateSign(isProgess ? '2' : '5')">{{
                        progessText1
                }}</el-button>
                <el-button type="primary" :disabled="clickSubmit" @click="templateSign(isProgess ? '1' : '4')">{{
                        progessText2
                }}</el-button>
            </div>
        </div>
        <template-list ref="temp" @saveBatch="saveBatchHandle"></template-list>
        <el-drawer title="" :visible.sync="descOpen" direction="rtl" custom-class="desc-drawer" append-to-body
            :show-close="true" :modal="false" :withHeader="true" size="80%">
            <div>
                <desc-drawer :from="'myLaunch'" :descData="descData" @changeDescOpen="changeDescOpen"></desc-drawer>
            </div>
        </el-drawer>
        <el-dialog :title="userContact.title" :visible.sync="userContact.userContactShow" width="590px" append-to-body
            :close-on-click-modal="false">
            <div style="padding-bottom: 25px">
                <el-table :data="userContact.contactList" style="width: 100%; width: 100%">
                    <el-empty description="暂无数据" slot="empty"></el-empty>
                    <el-table-column label="选择" prop="check" width="55" align="center">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.check" @change="handleSelectionChange(scope.row.id)">
                            </el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="companyName" label="企业名称" align="center"
                        v-if="userContact.queryParams.subject == 'company'">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.companyName" placement="top" effect="light"
                                v-if="scope.row.subject == 'company'">
                                <div class="scope-content">
                                    <span>{{ scope.row.companyName }}</span>
                                </div>
                            </el-tooltip>
                            <div class="scope-content" v-else>
                                <span>-</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="subject" label="联系人类型" align="center">
                        <template slot-scope="scope">
                            <div class="scope-content">
                                <span>{{
                                        scope.row.subject == "person" ? "个人" : "企业"
                                }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="personName" label="联系人姓名" align="center">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.personName" placement="top" effect="light">
                                <div class="scope-content">
                                    <span>{{ scope.row.personName }}</span>
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="personAddress" label="联系方式" align="center">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.personAddress" placement="top" effect="light">
                                <div class="scope-content">
                                    <span>{{ scope.row.personAddress }}</span>
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pager-layer">
                    <el-pagination v-if="
                        userContact.contactList &&
                        userContact.contactList.length &&
                        userContact.total > 10
                    " :total="userContact.total" :current-page.sync="userContact.queryParams.pageNum"
                        style="margin-top: 8px; position: absolute; right: 8px" layout="total, prev, pager, next"
                        :page-size.sync="userContact.queryParams.pageSize" @size-change="sizeChange"
                        @current-change="pageChange" />
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="useContactConfirm" size="small">确定</el-button>
                <el-button @click="cancelUseContact" size="small">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Loading } from "element-ui";
import { mapState } from "vuex";
import { getToken, getConsoleUrl } from "@/utils/auth";
import {
    getSignerInfo,
    contractTemplateImgApi,
    templateEditApi,
    getTemplatetSignListApi,
    getTemplateInfoApi,
    downloadTemplateApi,
    createContractByTemplateApi,
} from "@/api/template/index";
import { getDraftInfo, saveDraft, getSignFileImgArrayApi, updateTaskStatus2Send } from "@/api/unifysign/sign";
import { getContractTypeApi, getContractInfoApi } from "@/api/sign/flow";
import { getIsNotProgessApi } from "@/api/sign/set-control";
import { parseTime, downloadFile } from "@/utils/index";
import templateList from "../sign/template-list";
import lightHeader from "@/components/lightHeader";
import descDrawer from "./descDrawer";
import moment from "moment";
export default {
    components: {
        templateList,
        descDrawer,
        lightHeader,
    },
    computed: {
        ...mapState(["companyList", "currentSpace", "userInfo"]),
        isUser() {
            return this.$route.query.isuse == 1 ? true : false;
        },
        uploadData() {
            if (this.currentSpace) {
                return { companyId: this.currentSpace.companyId };
            } else {
                return { companyId: "" };
            }
        },
        backUrl() {
            if (this.$route.query.from) {
                return this.$route.query.from.replace(/\!\!/g, "?");
            } else {
                return true;
            }
        },
    },
    data() {
        return {
            signId: "",
            tenantId: this.$store.state.currentSpace.tenantId,
            spaceList: this.$store.state.spaceInfoList,
            filesForm: {
                taskName: "",
                signExpireTime: "",
            },
            signFileInfoArray: [],

            // taskName: "",
            // signExpireTime: "",
            fileIdArray: [],

            clickSubmit: false,
            templateUploadUrl:
                ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "api/common/v1/open/uploadSignFile",
            templateUrl:
                ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "contractTemplate/saveTemplate",
            myHeaders: {
                Authorization: getToken(),
            },
            // uploadData: {
            //   companyId: this.currentSpace.companyId || ''
            // },
            dialogVisible: false,
            pngList: [],
            percentage: 0,

            filesRules: {},
            contractTypes: [],
            defaultPDF: require("@/assets/images/sign/pdf.png"),
            disabled: false,
            isBatch: "",
            signatoryList: [],
            batchSignatoryList: [],
            isEdit: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                },
            },
            progessText1: "送审",
            progessText2: "保存待送审",
            tempList: [],
            isBatchOk: false,
            batchMsg: "",
            isProgess: false,
            keyWordMap: {},
            batchType: 0,
            uploadingLoading: false,

            descOpen: false,
            descData: {},

            userContact: {
                title: "",
                userContactShow: false,
                total: "",
                multipleSelection: undefined,
                refSequence: "",
                queryParams: {
                    pageNum: 1,
                    pageSize: 5,
                    subject: "",
                },
                contactList: [],
            },
            taskStatus: ""
        };
    },
    watch: {
        descOpen(newV, oldV) {
            if (newV) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
        },
    },
    created() {
        this.sid = this.$route.query.sid;

        if (this.sid) {
            getDraftInfo({
                sid: this.sid,
            }).then((res) => {
                if (res.code !== 200) {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "warning",
                    });
                } else {
                    this.filesForm.taskName = res.data.taskName;
                    this.filesForm.signExpireTime = res.data.signExpireTime;
                    this.taskStatus = res.data.taskStatus;
                    // this.signFileInfoArray = res.data.signFileInfoArray;

                    res.data.signFileInfoArray.map((item) => {
                        item.uid = item.fileId;
                        item.name = item.fileName;
                        this.fileIdArray.push(item.fileId);
                    });
                    this.$refs.upload.uploadFiles.push(...res.data.signFileInfoArray);
                    this.signatoryList.push(...res.data.signUserArray);
                    this.signatoryList.map((item) => {
                        this.$set(item, "tip", "");
                        this.$set(item, "tipCompany", "");
                        this.handleGetSignerInfo(item, item.signSubject);
                        if (
                            item.signSubject === "company" &&
                            item.companyAgentName &&
                            item.companyAgentAddress
                        ) {
                            this.handleGetSignerInfo(item, "agent");
                        }
                    });
                }
            });
        }
        // if (this.$route.query.templateId) {
        // 	this.getTemplatetSignListHandle();
        // 	this.getTemplateInfoHandle();
        // 	// this.fileId = this.$route.query.templateId;
        // }
        // if (this.$route.query.isuse == 1) {
        // 	this.getIsNotProgessHandle();
        // }
        // this.getContractTypeHandle();
    },
    methods: {
        useContactConfirm() {
            if (!this.userContact.multipleSelection) {
                this.$message({
                    showClose: true,
                    message: "请先选择联系人",
                    type: "warning",
                });
                return;
            }
            this.userContact.userContactShow = false;
            const ref = this.signatoryList.find((_item) => {
                return (_item.signSequence == this.userContact.refSequence);
            });
            if (ref.signSubject == "company") {
                ref.companyName = this.userContact.multipleSelection.companyName;
                ref.companyAgentName = this.userContact.multipleSelection.personName;
                ref.companyAgentAddress =
                    this.userContact.multipleSelection.personAddress;
                this.handleGetSignerInfo(ref, ref.signSubject);
                if (ref.companyAgentAddress) {
                    this.handleGetSignerInfo(ref, "agent");
                }
            } else {
                ref.personName = this.userContact.multipleSelection.personName;
                ref.personAddress = this.userContact.multipleSelection.personAddress;
                this.handleGetSignerInfo(ref, ref.signSubject)
            }

        },
        cancelUseContact() {
            this.userContact.userContactShow = false;
        },
        handleSelectionChange(val) {
            this.userContact.contactList.map((_item) => {
                if (_item.id === val) {
                    _item.check = true;
                    this.userContact.multipleSelection = _item;
                } else {
                    _item.check = false;
                }
            });
        },
        sizeChange() {
            this.toQuery();
        },
        pageChange() {
            this.toQuery();
        },
        toQuery() {
            this.getContactList();
        },
        handleUploaded() {
            this.uploadingLoading = false;
        },
        handleUploading() {
            this.uploadingLoading = true;
        },
        handleGetSignerInfo(signObj, signBody) {
            return;
            if (
                signBody === "person" &&
                (!signObj.personAddress || !signObj.personName)
            ) {
                signObj.tip = "";
                return;
            }
            if (
                signBody === "agent" &&
                (!signObj.companyAgentAddress || !signObj.companyAgentName)
            ) {
                signObj.tip = "";
                return;
            }
            if (signBody === "company" && !signObj.companyName) {
                signObj.tipCompany = "";
                return;
            }

            let params = {};
            if (signBody === "person") {
                params.signSubject = "person";
                params.personAddress = signObj.personAddress;
                params.personName = signObj.personName;
            } else if (signBody === "agent") {
                params.signSubject = "person";
                params.personAddress = signObj.companyAgentAddress;
                params.personName = signObj.companyAgentName;
            } else {
                params.signSubject = "company";
                params.companyName = signObj.companyName;
            }

            getSignerInfo(params).then((res) => {
                if (signBody == "company") {
                    signObj.tipCompany =
                        res.data.status == "passAuth" ? "已实名" : "未实名";
                } else {
                    signObj.tip = res.data.status == "passAuth" ? "已实名" : "未实名";
                }
            });
        },

        returnIndex() {
            // this.$router.push('/')
            window.location.href = getConsoleUrl() + "/templateCenter/template";
        },
        handleFileSuccess(response, file, fileList) {
            if (response.code != 200) {
                this.$message({
                    showClose: true,
                    message: response.message,
                    type: "warning",
                });
                // this.$refs.upload.clearFiles();
                // this.isEdit = false
                // this.fileId = "";
                // this.fileIdArray = [];
            } else {
                // this.defaultPDF =
                this.fileIdArray.push(response.data.signFileId);
                // this.filesForm.cname = file.name.substring(
                // 	0,
                // 	file.name.lastIndexOf(".")
                // );
                this.isUpload = true;

                // var uploadTimer = null;
                // var progressTimer = null;

                // uploadTimer = setInterval(() => {
                // 	this.percentage += 2;
                // 	if (this.percentage >= 99) {
                // 		this.percentage = 99;
                // 		clearInterval(uploadTimer);

                // 		progressTimer = setInterval(() => {
                // 			contractTemplateImgApi(
                // 				this.fileId || this.$route.query.templateId
                // 			)
                // 				.then(res => {
                // 					if (res.code == "0") {
                // 						this.percentage = 100;
                // 						clearInterval(progressTimer);
                // 					}
                // 				})
                // 				.catch(err => {
                // 					console.log(err);
                // 				});
                // 		}, 1000);
                // 	}
                // }, 60);
            }
        },
        handleFileError(err, file, fileList) {
            console.log(err);
            this.$message({
                showClose: true,
                message: "文件上传失败！",
                type: "warning",
            });
        },
        handleTemplateBeforeUpload(file) {
            let type = file.name.substring(file.name.lastIndexOf(".") + 1);
            if (type != "pdf") {
                // this.$refs.upload.clearFiles();
                this.$message.warning(`请上传pdf文件！`);
                return false;
            } else {
                if (file.size > 100 * 1024 * 1024) {
                    this.$message.warning(`文件大小超出100M限制，请重新上传！`);
                    return false;
                } else {
                }
            }

            if (file.size > 100 * 1024 * 1024) {
                this.$message.warning(`文件大小超出100M限制，请重新上传！`);
                return false;
            } else {
            }
        },
        // handleFilePreview(file) {
        //   if (file.fileImgArray) {
        //     this.pngList = file.fileImgArray;
        //     this.dialogVisible = true;
        //   } else {
        //     // 查看上传文件
        //     getSignFileImgArrayApi({
        //       signFileId: file.response.data.signFileId,
        //     }).then((res) => {
        //       // this.pngList = res.data.signFileImgArray.map(el => {
        //       // 	return ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + el;
        //       // });
        //       this.pngList = res.data.signFileImgArray;
        //       this.dialogVisible = true;
        //     });
        //   }
        // },
        handleRemove(file) {
            // 缩略图模板里删除文件
            let fileList = this.$refs.upload.uploadFiles;
            let index = fileList.findIndex((fileItem) => {
                return fileItem.uid === file.uid;
            });
            fileList.splice(index, 1);
            this.fileIdArray.splice(index, 1);
            // this.$refs.upload.clearFiles();
            // this.isEdit = false;
            // this.fileId = "";
            // this.percentage = 0;
        },
        checkContractName(rule, value, callback) {
            var reg = new RegExp(
                '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
            );
            if (!reg.test(value)) {
                callback(new Error('合同名不能包含下列任何字符:/:*?"<>|'));
            } else {
                callback();
            }
        },
        getContractImgsHandle() {
            return new Promise((resolve, reject) => {
                contractTemplateImgApi(this.fileId || this.$route.query.templateId)
                    .then((res) => {
                        console.log(res);
                        if (res.code !== 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {
                            resolve(res.data.pngList);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        },
        getContractTypeHandle() {
            getContractTypeApi(this.currentSpace.companyId).then((res) => {
                if (res.code != "0") {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "warning",
                    });
                } else {
                    this.contractTypes = res.data;
                }
            });
        },
        addSignatory(signSubject) {
            var signSequence = 0;
            if (this.batchSignatoryList.length > 0) {
                signSequence = this.signatoryList.length + 2;
            } else {
                signSequence = this.signatoryList.length + 1;
            }
            this.signatoryList.push({
                signSequence: signSequence,
                companyName: "",

                signSubject: signSubject,
                // userName: "",
                personAddress: "",
                personName: "",
                companyAgentAddress: "",
                companyAgentName: "",
                // agentList: [],
                // companyId: "",
                tip: "",
                tipCompany: "",
            });
        },
        deleteSignatory(index) {
            this.signatoryList.forEach((item, i) => {
                if (item.signSequence === index) {
                    this.signatoryList.splice(i, 1);
                }
            });

            this.signatoryList.forEach((d, j) => {
                d.signSequence = j + 1;
            });
        },
        batchHandle(type) {
            this.isBatch = type;
            this.batchType = type;
            this.batchSignatoryList.push({
                signSequence: this.signatoryList.length + 1,
                signSubject: type,
                personAddress: "",
                personName: "",
                agentAccount: "",
                agentName: "",
            });
        },
        deleteBatchSignatory() {
            this.isBatch = "";
            this.batchSignatoryList = [];
            this.signatoryList.forEach((item, index) => {
                item.signSequence = parseInt(index) + 1;
            });
        },
        handleLaunchSign() { },
        templateHandle(type) {
            if (this.uploadingLoading) {
                this.$message({
                    showClose: true,
                    message: "请等待文件上传完毕！",
                    type: "warning",
                });
                return;
            }
            this.$refs.filesForm.validate((valid) => {
                if (valid) {
                    var reg = /^[\u0391-\uFFE5]+$/;
                    if (!this.fileIdArray.length) {
                        this.$message({
                            showClose: true,
                            message: "请上传合同！",
                            type: "warning",
                        });
                        return;
                    }
                    if (!this.signatoryList.length) {
                        this.$message({
                            showClose: true,
                            message: "请添加签署人！",
                            type: "warning",
                        });
                        return;
                    }
                    // 提交保存项
                    saveDraft({
                        sid: this.sid ? this.sid : "",
                        taskName: this.filesForm.taskName,
                        taskType: "normal",
                        signExpireTime: this.filesForm.signExpireTime,
                        // initiatorTenantId: this.tenantId,
                        signUserArray: this.signatoryList,
                        signFileIdArray: this.fileIdArray,
                    }).then((res) => {
                        if (res.code !== 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {
                            if (type == "save") {
                                this.$message({
                                    showClose: true,
                                    message: "保存成功",
                                    type: "success",
                                });
                                // if (this.$route.query.from) {
                                //     this.$router.push({
                                //         path: this.$route.query.from.replace(/\!\!/g, "?"),
                                //     });
                                // } else {
                                //     this.$router.go(-1);
                                // }
                            } else if (type == "toSign") {
                                // 指定签署位置
                                let sid = res.data.sid;
                                this.$router.push({
                                    path: "/sign",
                                    query: {
                                        sid,
                                        from: this.$route.query.from,
                                    },
                                });
                            } else {
                                // 发起签署
                                updateTaskStatus2Send({
                                    sid: this.sid
                                }).then(res => {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: res.code == 200 ? "success" : "warning"
                                    });
                                    if (res.data.signLink) {
                                        location.href = res.data.signLink
                                    }
                                })
                            }
                        }
                        console.log(res);
                    });

                    // this.getContractImgsHandle().then(data => {
                    // 	if (this.signatoryList.length > 0) {
                    // 		let isvalid = true;

                    // 		if (isvalid) {
                    // 			let signatoryList = [];
                    // 			this.signatoryList.forEach(item => {
                    // 				signatoryList.push({
                    // 					signingBody: item.signingBody,
                    // 					signSequence: item.signSequence,
                    // 					account: item.account,
                    // 					subjectName: item.subjectName,
                    // 					agentAccount: item.agentAccount,
                    // 					agentName: item.agentName
                    // 				});
                    // 			});

                    // 			this.toPositionHandle(signatoryList);
                    // 		}
                    // 	} else {
                    // 		this.$message({
                    // 			showClose: true,
                    // 			message: "请添加签署方！",
                    // 			type: "warning"
                    // 		});
                    // 		console.log("error submit!");
                    // 		return false;
                    // 	}
                    // });
                }
            });
        },
        toPositionHandle(signatoryList) {
            let loadingInstance = Loading.service({
                fullscreen: true,
            });
            this.isDraftOk = true;
            templateEditApi({
                contractName: this.filesForm.cname,
                companyId: this.currentSpace.companyId || "",
                contractFileId: this.fileId,
                contractTypeId: this.filesForm.ctype,
                templateId: this.$route.query.templateId || this.fileId,
                signatoryList,
                batchSignatoryList: this.batchSignatoryList,
            })
                .then((res) => {
                    console.log(res);
                    this.$nextTick(() => {
                        // 以服务的方式调用的 Loading 需要异步关闭
                        loadingInstance.close();
                    });
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                        this.isDraftOk = false;
                        return;
                    } else {
                        this.$router.push({
                            path: "/set-temp-control",
                            query: {
                                templateId: res.data.contractId,
                            },
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getTemplatetSignListHandle() {
            getTemplatetSignListApi({
                templateId: this.$route.query.templateId,
                nocache: new Date().getTime(),
            })
                .then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.signatoryList = res.data.signatoryList;
                        this.batchSignatoryList = res.data.batchSignatoryList;
                        if (this.batchSignatoryList.length > 0) {
                            this.isBatch = this.batchSignatoryList[0].signSubject;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getTemplateInfoHandle() {
            getTemplateInfoApi(this.$route.query.templateId)
                .then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.filesForm.cname = res.data.contractName;
                        this.filesForm.ctype = res.data.contractTypeId;
                        if (this.filesForm.cname) {
                            this.isEdit = true;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        downloadTemplateHandle() {
            downloadTemplateApi(this.$route.query.templateId).then((res) => {
                console.log(res);
                downloadFile(res, "模板文件", "xlsx");
            });
        },
        uploadTemplateSuccess(response, file, fileList) {
            console.log(response);
            if (response.code !== "0") {
                this.$message({
                    showClose: true,
                    message: response.message,
                    type: "warning",
                });
            } else {
                this.$refs.temp.templateData = response.result.batchSignatoryList;
                this.signatoryList = response.result.signatoryList;
                this.batchSignatoryList = response.result.batchSignatoryList;
                this.keyWordMap = response.result.keyWordMap;
                if (this.batchSignatoryList.length > 0) {
                    this.isBatchOk = true;
                    this.$refs.temp.templateType = this.batchSignatoryList[0].signSubject;
                } else {
                    this.isBatchOk = false;
                }

                this.isBatch = "";
                this.batchMsg = response.result.msg;
            }
        },
        showBatchSignatory() {
            this.$refs.temp.dialogVisible = true;
        },
        saveBatchHandle(batchData) {
            this.batchSignatoryList = batchData;
        },
        getIsNotProgessHandle() {
            getIsNotProgessApi({
                contractId: this.$route.query.templateId,
            })
                .then((res) => {
                    console.log(res);
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        if (res.data.success == "false") {
                            this.progessText1 = "发送";
                            this.progessText2 = "保存待发送";
                            this.isProgess = false;
                        } else {
                            this.progessText1 = "送审";
                            this.progessText2 = "保存待送审";
                            this.isProgess = true;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        templateSign(status) {
            this.$refs.filesForm.validate((valid) => {
                if (valid) {
                    var reg = /^[\u0391-\uFFE5]+$/;
                    if (!this.fileId && !this.$route.query.templateId) {
                        this.$message({
                            showClose: true,
                            message: "请上传合同！",
                            type: "warning",
                        });

                        return;
                    }

                    var dateTime = new Date(this.filesForm.cdate).getTime();
                    var now = new Date();
                    var year = now.getFullYear();
                    var month = now.getMonth();
                    var date = now.getDate();
                    var time = year + "-" + (month + 1) + "-" + date;
                    var todayTime = new Date(time).getTime();

                    if (dateTime < todayTime) {
                        this.$message({
                            showClose: true,
                            message: "请修改截止日期！",
                            type: "warning",
                        });

                        return;
                    }

                    if (this.signatoryList.length > 0) {
                        let isvalid = true;

                        for (var i = 0; i < this.signatoryList.length; i++) {
                            if (!this.signatoryList[i].personAddress) {
                                this.$message({
                                    showClose: true,
                                    message: "账号不能为空！",
                                    type: "warning",
                                });

                                isvalid = false;
                                break;
                            }

                            if (
                                this.signatoryList[i].signSubject == "person" &&
                                !this.signatoryList[i].personName
                            ) {
                                this.$message({
                                    showClose: true,
                                    message: "姓名不能为空！",
                                    type: "warning",
                                });

                                isvalid = false;
                                break;
                            }

                            if (
                                this.signatoryList[i].signSubject == "company" &&
                                !this.signatoryList[i].personName
                            ) {
                                this.$message({
                                    showClose: true,
                                    message: "企业名称不能为空！",
                                    type: "warning",
                                });

                                isvalid = false;
                                break;
                            }

                            if (
                                this.signatoryList[i].signSubject == "company" &&
                                !this.signatoryList[i].agentAccount
                            ) {
                                this.$message({
                                    showClose: true,
                                    message: "经办人账号不能为空！",
                                    type: "warning",
                                });

                                isvalid = false;
                                break;
                            }

                            if (
                                this.signatoryList[i].signSubject == "company" &&
                                !this.signatoryList[i].agentName
                            ) {
                                this.$message({
                                    showClose: true,
                                    message: "经办人姓名不能为空！",
                                    type: "warning",
                                });

                                isvalid = false;
                                break;
                            }
                        }

                        if (isvalid) {
                            let signatoryList = [];
                            this.signatoryList.forEach((item) => {
                                signatoryList.push({
                                    signSubject: item.signSubject,
                                    signSequence: item.signSequence,
                                    personAddress: item.personAddress,
                                    personName: item.personName,
                                    agentAccount: item.agentAccount,
                                    agentName: item.agentName,
                                });
                            });

                            for (var i = 0; i < signatoryList.length; i++) {
                                for (var j = i + 1; j < signatoryList.length; j++) {
                                    if (
                                        signatoryList[i].signSubject ===
                                        signatoryList[j].signSubject &&
                                        signatoryList[i].personAddress ===
                                        signatoryList[j].personAddress &&
                                        signatoryList[i].personName ===
                                        signatoryList[j].personName &&
                                        signatoryList[i].agentAccount ===
                                        signatoryList[j].agentAccount &&
                                        signatoryList[i].agentName === signatoryList[j].agentName
                                    ) {
                                        this.$message({
                                            showClose: true,
                                            message: "存在重复签署方，请删除重复用户后再尝试提交！",
                                            type: "warning",
                                        });

                                        find = true;

                                        break;
                                    }
                                }

                                if (find) break;
                            }

                            if (this.batchSignatoryList.length > 0) {
                                for (var i = 0; i < signatoryList.length; i++) {
                                    for (var j = 0; j < this.batchSignatoryList.length; j++) {
                                        if (
                                            signatoryList[i].signSubject ===
                                            this.batchSignatoryList[j].signSubject &&
                                            signatoryList[i].personAddress ===
                                            this.batchSignatoryList[j].personAddress &&
                                            signatoryList[i].personName ===
                                            this.batchSignatoryList[j].personName &&
                                            signatoryList[i].agentAccount ===
                                            this.batchSignatoryList[j].agentAccount &&
                                            signatoryList[i].agentName ===
                                            this.batchSignatoryList[j].agentName
                                        ) {
                                            this.$message({
                                                showClose: true,
                                                message: "存在重复签署方，请删除重复用户后再尝试提交！",
                                                type: "warning",
                                            });

                                            find = true;

                                            break;
                                        }
                                    }

                                    if (find) break;
                                }
                            }

                            this.createContractByTemplateHandle(signatoryList, status);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: "请添加单个签署方！",
                            type: "warning",
                        });
                        console.log("error submit!");
                        return false;
                    }
                } else {
                }
            });
        },
        createContractByTemplateHandle(signatoryList, status) {
            createContractByTemplateApi({
                templateId: this.$route.query.templateId,
                status: status,
                endDate: moment(this.filesForm.cdate).format("YYYY-MM-DD"),
                contractName: this.filesForm.cname,
                batchSignatoryList: this.batchSignatoryList,
                keyWordMap: this.keyWordMap,
                signatoryList: signatoryList,
            })
                .then((res) => {
                    console.log(res);
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.$message({
                            message: "发起成功！",
                            type: "success",
                        });

                        this.$router.push("/");
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleFilePreview(file) {
            // 保存草稿已上传的文件预览
            if (file.fileImgArray && file.fileImgArray.length) {
                this.$nextTick(() => {
                    this.descData = {
                        signFileInfoArray: [
                            {
                                fileName: file.fileName,
                                fileImgArray: file.fileImgArray,
                            },
                        ],
                    };
                    this.descOpen = true;
                });
            } else {
                // 查看上传文件
                getSignFileImgArrayApi({
                    signFileId: file.response.data.signFileId,
                }).then((res) => {
                    this.$nextTick(() => {
                        this.descData = {
                            signFileInfoArray: [
                                {
                                    fileName: file.name,
                                    fileImgArray: res.data.signFileImgArray,
                                },
                            ],
                        };
                        this.descOpen = true;
                    });
                });
            }
        },
        changeDescOpen(status) {
            this.descOpen = status;
        },
    },
};
</script>
<style>
#tempcreate-layer .el-table .cell {
    padding: 0 20px;
    font-size: 14px;
}

#tempcreate-layer .el-table tr {
    height: 72px;
}

#tempcreate-layer .el-table th>.cell {
    font-size: 16px;
}

.tempcreate-upload .el-upload--picture-card {
    width: 142px;
    height: 142px;
    line-height: 138px;
}

.hide .el-upload--picture-card {
    display: none;
}

#tempcreate-layer .el-loading-spinner {
    height: 166px;
    margin-top: -43px;
}

.el-upload-list__item {
    transition: all 0.3s ease;
}
</style>
<style lang="scss" scoped>
.tempcreate-content {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    // margin-top: 30px;

    /deep/ .el-tabs--border-card {
        border: none;
        box-shadow: none;

        .el-tabs__header {
            background: #f0f0f5;
        }

        .el-tabs__item {
            margin-right: 12px;
            background: #e5e5e5;
            border: none;

            &.is-active {
                background: #fff;
            }
        }

        .el-tabs__content {
            padding: 0;
        }
    }

    .tempcreate-files {
        // margin-top: 30px;
        background: #fff;
        padding: 26px 23px;

        .tempcreate-title {
            padding: 1px 8px;
            font-size: 15px;
            font-weight: 400;
            color: #333333;
            border-left: 3px solid #3296fa;
        }

        .el-form-item {
            margin-top: 25px;
            padding: 0 13px;
            color: #666666;
        }

        label {
            width: 98px;
            color: #666666;
            display: inline-block;
        }
    }

    .tempcreate-upload {
        // width: 148px;
        // height: 148px;
        // margin: 28px auto 0;
        // overflow: hidden;
        margin-top: 27px;

        /deep/ .el-loading-mask {
            height: 140px;
            border-radius: 10px;
        }

        .uploaded-list {
            .uploaded-item {
                overflow: visible;
                width: 144px;
                height: 144px;
                background-color: #fff;
                border: 1px solid #c0ccda;
                border-radius: 6px;
                box-sizing: border-box;
                margin: 0 8px 8px 0;
                display: inline-block;
                position: relative;

                .file-thumb {
                    width: 142px;
                    height: 142px;
                    border-radius: 6px;
                    overflow: hidden;
                }

                .file-name {
                    width: 142px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: center;
                    font-size: 14px;
                    color: #606266;
                    line-height: 1.8;
                }

                .file-actions {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    cursor: default;
                    text-align: center;
                    color: #fff;
                    opacity: 0;
                    font-size: 20px;
                    background-color: rgba(0, 0, 0, 0.5);
                    transition: opacity 0.3s;

                    .file-preview {
                        cursor: pointer;
                    }

                    .file-delete {
                        margin-left: 15px;
                        cursor: pointer;
                    }

                    &::after {
                        display: inline-block;
                        content: "";
                        height: 100%;
                        vertical-align: middle;
                    }
                }

                .file-actions:hover {
                    opacity: 1;
                }
            }
        }

        /deep/ .el-upload-list--picture-card .el-upload-list__item {
            overflow: visible;
            width: 142px;
            height: 142px;

            .file-name {
                width: 142px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
            }

            .el-upload-list__item-thumbnail {
                width: 140px;
                height: 140px;
                border-radius: 6px;
                overflow: hidden;
            }
        }
    }
}

.tempcreate-users-box {
    padding: 0 40px;
    background: #ffffff;
    margin-top: 18px;
    padding: 22px 39px 0;

    .add-btn {
        padding: 11px 14px;
        background: #3296fa;
        border-radius: 10px;
        font-size: 14px;
        text-align: center;
        font-weight: 400;
        color: #ffffff;
    }

    // .sign-btns button.sign-button {
    //   padding: 12px 18px;
    //   background: #3296fa;
    //   border-radius: 10px;
    //   font-size: 16px;
    //   font-weight: 400;
    //   color: #ffffff;
    //   &.line {
    //     border: 1px solid #999999;
    //     background: #fff;
    //     color: #999999;
    //     margin-left: 80px;
    //   }
    // }

    .signatory-list {
        margin-top: 23px;

        // width: 1120px;
        .signatory-item {
            box-sizing: border-box;
            // width: 1120px;
            // border: 3px dashed #f0f0f5;
            border-radius: 2px;
            overflow: hidden;
            margin-bottom: 15px;
            padding: 0 20px 9px 20px;
            position: relative;
            font-size: 14px;
            font-weight: 400;
            color: #333333;

            &.signatory-batch {
                padding-bottom: 18px;
            }

            &.signatory-batch .signatory-item-title {
                margin-bottom: 15px;
            }

            .signatory-item-title {
                margin: 16px 0 27px 0;
                font-size: 16px;
                color: #000000;
                font-weight: bold;
                line-height: 16px;
            }

            .signatory-body {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 11px;

                .sub-title {
                    // margin-right: 18px;
                    width: 80px;
                }
            }

            .signatory-form-item {
                width: 233px;
                float: left;
                margin-right: 34px;
            }

            .auth-tag {
                width: 53px;
                padding: 2px 0;
                border: 1px solid #00d0ce;
                border-radius: 3px;
                color: #00d0ce;
                font-size: 12px;
                text-align: center;
                margin-left: -15px;

                &.icon-question {
                    border: none;
                    color: #e6a23c;
                    font-size: 20px;
                    cursor: pointer;
                }

                .auth-tip {
                    display: flex;
                    align-items: center;

                    .auth-tip-text {
                        font-size: 16px;
                        white-space: nowrap;
                        margin-top: -2px;
                        margin-right: 3px;
                    }
                }
            }
        }
    }
}

#tempcreate-layer {
    background: #f0f0f5;
    min-height: 100vh;
    padding-top: 30px;
}

header {
    width: 100%;
    height: 71px;
    background: rgba(35, 43, 58, 1);
    box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
    line-height: 71px;
    overflow: hidden;
}

.header-center {
    width: 1200px;
    margin: 0 auto;
    line-height: 71px;
    height: 71px;
    overflow: hidden;
    position: relative;
}

.logo {
    margin-top: 16px;
    margin-left: 0;
    width: 111px;
    float: left;
}

.logo-text {
    margin-left: 42px;
    font-size: 24px;
    color: #ffffff;
}

.logo-s-title {
    font-size: 24px;
    color: #ffffff;
    margin-left: 24px;
}

.return-index {
    height: 71px;
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    font-size: 24px;
    color: #ffffff;
    line-height: 71px;
}

// .tempcreate-content {
// 	width: 1200px;
// 	margin: 30px auto;
// }

.tempcreate-nav {
    width: 1200px;
    height: 54px;
    overflow: hidden;
    line-height: 42px;
    color: #333333;
    font-size: 16px;
    overflow-x: auto;
}

.tempcreate-nav a {
    display: block;
    float: left;
    width: 139px;
    height: 43px;
    overflow: hidden;
    padding: 0 18px;
    margin-right: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #e5e5e5;
    text-align: center;
}

.tempcreate-nav a:last-child {
    margin-right: 0;
}

.tempcreate-nav a.active {
    background: #ffffff;
}

.upload-tip {
    position: relative;
    top: -120px;
    font-size: 14px;
    color: #999999;
}

.upload-tip2 {
    text-align: center;
    font-size: 14px;
    color: #d75c57;
    margin-top: 20px;
}

.upload-progress {
    width: 320px;
    margin: 10px auto 0;
}

.progress-title {
    font-size: 14px;
    color: #606266;
    float: left;
}

.progress-box {
    width: 320px;
    /* float: right; */
    margin-right: -30px;
    margin-top: 4px;
}

.files-form-box {
    width: 320px;
    margin: 26px auto 0;
}

.signatory-form-item-title {
    font-size: 14px;
    color: #333333;
    margin-bottom: 10px;
}

.signatory-form-item-inp {
    font-size: 14px;
    color: #666666;
    line-height: 40px;
    position: relative;

    .tip {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
    }
}

.signatory-delete {
    right: 20px;
    top: 50%;
    margin-top: -12px;
    position: absolute;
    font-size: 20px;
    cursor: pointer;

    &:hover,
    &:active,
    &:focus {
        color: #f56c6c !important;
        background: #fef0f0 !important;
        border-color: #fbc4c4 !important;
    }
}

.signatory-batch,
.signatory-batch-success {
    box-sizing: border-box;
    width: 1120px;
    // height: 100px;
    border: 2px dashed rgba(240, 240, 245, 1);
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 15px;
    padding: 0 20px;
    position: relative;
}

.signatory-batch-content {
    background: rgba(160, 160, 160, 0.08);
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    padding: 4px;

    >div {
        padding: 8px;
    }

    .circle {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 10px;
        font-weight: bold;
        color: #ffffff;
        background: #3296fa;
        border-radius: 20px;
        margin-right: 8px;
    }

    /deep/ .el-button--text {
        padding: 0;
    }

    .upload-btn {
        display: inline-block;
        margin-left: 10px;

        /deep/ .el-button {
            width: 80px;
            height: 36px;
            background: #3296fa;
            border-radius: 10px;
        }
    }
}

.signatory-batch-item {
    height: 20px;
    line-height: 20px;
    margin-bottom: 15px;
}

.step {
    float: left;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    text-align: center;
    color: #ffffff;
    background: #e85052;
    margin-right: 10px;
}

.step-cont {
    font-size: 14px;
    color: #666666;
}

.download-template {
    color: #d75c57;
}

.upload-template {
    height: 36px;
    /* background: #E85052; */
    color: #ffffff;
    margin-top: -5px;
    margin-left: 15px;
    width: 98px;
    float: left;
    overflow: hidden;
}

.signatory-batch-content2 {
    margin-top: 39px;
    margin-left: 40px;
    font-size: 14px;
    color: #666666;
}

.signatory-batch-text {
    /* margin-bottom: 28px; */
    font-size: 14px;
}

.show-signatory {
    color: #e25658;
    margin-right: 5px;
}

.mail-icon {
    display: block;
    width: 25px;
    position: absolute;
    right: 5px;
    top: 8px;
    z-index: 999;
    cursor: pointer;
}

.sign-btns {
    width: 750px;
    margin: 40px auto 0;
    display: flex;
    justify-content: center;
    padding-bottom: 40px;
}

.sign-btns .el-button {
    width: 150px;
    height: 47px;
}

.sign-btns .el-button+.el-button {
    margin-left: 50px;

}

// .sign-btns button:hover {
//   background: #ffffff;
//   color: #606266;
//   border-color: #dcdfe6;
// }

.h180 {
    height: 180px !important;
}
</style>